import { useOrderContext } from "../contexts/OrderContext";
import { ProgressionReducerActionTypes } from "../contexts/reducers/progressionReducer";
import { StepsReducerActionTypes } from "../contexts/reducers/stepsReducer";

/**
 * Custom hook to manage progression within the NewOrderContext.
 * This hook can only be used within the NewOrderContext provider.
 */

export const useProgression = () => {
  const { progressLevel, dispatchProgressLevel, dispatchSteps } =
    useOrderContext();

  const jumpTo = (setProgressLevelTo: number) => {
    dispatchProgressLevel({
      type: ProgressionReducerActionTypes.Jump_To,
      value: setProgressLevelTo,
    });

    dispatchSteps({
      type: StepsReducerActionTypes.ResetDoneOnJump,
      value: setProgressLevelTo,
    });
  };

  const goNext = () => {
    dispatchSteps({
      type: StepsReducerActionTypes.SetToDone,
      value: progressLevel,
    });

    dispatchProgressLevel({
      type: ProgressionReducerActionTypes.Next,
    });
  };

  const goBack = () => {
    dispatchSteps({
      type: StepsReducerActionTypes.ResetDoneOnBack,
      value: progressLevel,
    });

    dispatchProgressLevel({
      type: ProgressionReducerActionTypes.Back,
    });
  };

  return { jumpTo, goNext, goBack };
};
